import React from 'react';

const ImageMask = ({bgUrl, children}) => (
  <div className="image mask-copy mask-copy--no-padding" style={{backgroundImage: `url('${bgUrl}')`}}>
    {children}
  </div>
);

export default ImageMask;
